import { servicesPages } from "./servicesPages";

const corePages = [
  {
    slug: "couvreur-94",
    footerLabel: "Couvreur 94",
    metaTitle: "Couvreur 94 – Réparation et rénovation de toiture | MSC Toitures",
    metaDescription:
      "MSC Toitures, couvreur dans le Val-de-Marne (94) : recherche de fuite, réparation, rénovation de toiture et zinguerie. Contactez-nous pour votre devis.",
    overline: "Entreprise de couverture — Val-de-Marne",
    h1: "Couvreur 94 : travaux de toiture dans le Val-de-Marne",
    intro: [
      "Chercher un couvreur dans le 94, c'est chercher avant tout un interlocuteur de confiance, proche de chez vous, capable de se déplacer rapidement pour constater l'état de votre toiture. Basée à Champigny-sur-Marne, l'entreprise de couverture MSC Toitures intervient dans l'ensemble du Val-de-Marne pour tous les travaux de toiture : réparation, rénovation, entretien, zinguerie et étanchéité.",
      "Notre approche est simple : le déplacement est gratuit, le devis est gratuit, et vous parlez directement à l'artisan couvreur qui interviendra chez vous. Pas de plateforme de mise en relation, pas de standard téléphonique : un contact direct, au 06 46 30 03 91 ou au 01 87 07 86 62.",
    ],
    blocks: [
      {
        h2: "Une entreprise de toiture implantée dans le 94",
        paragraphs: [
          "Notre showroom est situé au 34 boulevard de Polangis, à Champigny-sur-Marne. Cette implantation locale nous permet d'intervenir dans tout le département : le long de la Marne, de Saint-Maur-des-Fossés à Joinville-le-Pont et Nogent-sur-Marne, mais aussi dans le sud du 94, à Créteil, Maisons-Alfort, Vitry-sur-Seine, Ivry-sur-Seine, Villejuif ou Thiais.",
          "Connaître le territoire, c'est aussi connaître ses toitures : les tuiles mécaniques des pavillons de l'après-guerre, les toitures en zinc des immeubles anciens, les toits-terrasses des extensions récentes. Cette connaissance du bâti local nous aide à diagnostiquer vite et à proposer la bonne réparation.",
        ],
      },
      {
        h2: "Tous les travaux de couverture et de zinguerie",
        paragraphs: [
          "MSC Toitures prend en charge l'ensemble des travaux qui touchent à votre toit, du dépannage ponctuel au chantier de rénovation complet. Chaque intervention débute par un diagnostic gratuit à votre domicile.",
        ],
        list: [
          "Dépannage toiture et recherche de fuite",
          "Réparation de toiture et remplacement de tuiles",
          "Rénovation complète ou partielle de couverture",
          "Nettoyage, démoussage et entretien de toiture",
          "Travaux de zinguerie : gouttières, chéneaux, noues, abergements",
          "Étanchéité de toiture et traitement des points singuliers",
        ],
      },
      {
        h2: "Comment se déroule une demande d'intervention",
        paragraphs: [
          "Vous nous appelez ou vous remplissez le formulaire de devis en quelques minutes. Nous convenons ensemble d'un rendez-vous pour venir voir votre toiture — le déplacement est gratuit partout dans le Val-de-Marne. Sur place, nous examinons la couverture, la zinguerie et les zones sensibles, puis nous vous expliquons clairement ce que nous constatons.",
          "Vous recevez ensuite un devis détaillé et gratuit. Libre à vous d'accepter ou non : notre rôle est de vous donner une vision honnête de l'état de votre toit et des travaux réellement nécessaires.",
        ],
      },
      {
        h2: "Entretien, démoussage et charpente : le suivi complet de votre toit",
        paragraphs: [
          "Au-delà du dépannage, nous assurons le suivi de votre toiture dans la durée : démoussage et nettoyage adaptés au matériau, curage des gouttières, contrôle des points singuliers, et inspection de la charpente lors de chaque intervention. C'est cette approche complète qui évite les mauvaises surprises.",
          "Lors d'une réfection, la charpente est systématiquement vérifiée après la dépose de l'ancienne couverture : bois humides, chevrons fatigués, sections affaiblies par une ancienne fuite. Une réparation localisée au bon moment évite des travaux bien plus lourds.",
        ],
      },
      {
        h2: "Des pages dédiées à chaque prestation et à votre commune",
        paragraphs: [
          "Pour aller plus loin, consultez nos pages dédiées à chaque type de travaux — réparation, fuite, rénovation, réfection, zinguerie, gouttières, démoussage, entretien, charpente et étanchéité — ainsi que nos pages locales pour les communes proches de Champigny-sur-Marne : Joinville-le-Pont, Saint-Maur-des-Fossés, Nogent-sur-Marne, Le Perreux-sur-Marne, Villiers-sur-Marne, Bry-sur-Marne, Chennevières-sur-Marne et Le Plessis-Trévise.",
        ],
      },
    ],
    ctaTitle: "Un couvreur dans le 94, au bout du fil",
    photo: "/photos/chantier.webp",
    photoAlt: "Chantier de couverture MSC Toitures avec échafaudage dans le Val-de-Marne",
    linksBlock: {
      title: "Nos prestations et nos secteurs",
      links: [
        { to: "/couvreur-champigny-sur-marne", label: "Couvreur Champigny-sur-Marne" },
        { to: "/reparation-toiture-94", label: "Réparation toiture 94" },
        { to: "/fuite-toiture-94", label: "Fuite toiture 94" },
        { to: "/renovation-toiture-94", label: "Rénovation toiture 94" },
        { to: "/refection-toiture-94", label: "Réfection toiture 94" },
        { to: "/zinguerie-94", label: "Zinguerie 94" },
        { to: "/gouttiere-94", label: "Gouttières 94" },
        { to: "/demoussage-toiture-94", label: "Démoussage toiture 94" },
        { to: "/entretien-toiture-94", label: "Entretien toiture 94" },
        { to: "/charpente-94", label: "Charpente 94" },
        { to: "/etancheite-toiture-94", label: "Étanchéité toiture 94" },
      ],
    },
  },
  {
    slug: "couvreur-champigny-sur-marne",
    footerLabel: "Couvreur Champigny-sur-Marne",
    metaTitle: "Couvreur Champigny-sur-Marne — MSC Toitures | Réparation & rénovation de toiture",
    metaDescription:
      "MSC Toitures, votre couvreur à Champigny-sur-Marne (94500) : réparation de toiture, fuite, démoussage, gouttières et zinguerie. Showroom 34 boulevard de Polangis. Devis gratuit.",
    overline: "Notre ville d'ancrage — 94500",
    h1: "Couvreur à Champigny-sur-Marne : MSC Toitures, votre voisin couvreur",
    intro: [
      "C'est à Champigny-sur-Marne que MSC Toitures a établi son showroom, au 34 boulevard de Polangis. Si vous habitez Champigny — Le Plant, Le Boullereau, le centre-ville ou les bords de Marne — votre couvreur est tout simplement à côté de chez vous.",
      "Réparation de toiture, recherche de fuite, remplacement de tuiles, réparation de gouttières, démoussage : nous intervenons sur toute la commune avec le même principe qu'ailleurs dans le 94 — déplacement gratuit et devis gratuit.",
    ],
    blocks: [
      {
        h2: "Les toitures de Champigny, un paysage que nous connaissons bien",
        paragraphs: [
          "Champigny-sur-Marne est une ville majoritairement pavillonnaire. Ses toitures en tuiles plates ou mécaniques, posées pour beaucoup il y a plusieurs décennies, arrivent aujourd'hui à un âge où l'entretien devient décisif : mousse qui s'installe sur les versants nord, tuiles qui se fissurent après les gelées, gouttières qui se bouchent sous les arbres des jardins.",
          "Intervenir régulièrement dans la commune nous permet de reconnaître ces situations immédiatement et d'anticiper les points faibles typiques des toitures champenoises, quartier par quartier.",
        ],
      },
      {
        h2: "Un showroom pour parler de votre toit en face à face",
        paragraphs: [
          "Beaucoup d'entreprises de couverture n'ont aucune adresse où les rencontrer. Ce n'est pas notre cas : vous pouvez passer au 34 boulevard de Polangis pour nous présenter votre projet, montrer des photos de votre toiture et échanger directement avec nous.",
          "C'est aussi la garantie de savoir où nous trouver avant, pendant et après les travaux. Une entreprise locale, établie, joignable — cela change tout quand on confie son toit à quelqu'un.",
        ],
      },
      {
        h2: "Nos interventions à Champigny-sur-Marne",
        paragraphs: [
          "De la fuite urgente un soir d'orage au projet de rénovation réfléchi depuis des mois, nous prenons en charge tous les travaux de toiture sur la commune.",
        ],
        list: [
          "Recherche et réparation de fuites et infiltrations",
          "Réparation de toiture et remplacement de tuiles cassées",
          "Nettoyage et démoussage des couvertures",
          "Réparation et remplacement de gouttières",
          "Zinguerie : noues, chéneaux, abergements de cheminée",
          "Rénovation et réfection de toitures vieillissantes",
          "Contrôle de la charpente et petites réparations",
          "Reprise d'étanchéité des points singuliers",
        ],
      },
      {
        h2: "À deux pas du Perreux, de Joinville et de Bry",
        paragraphs: [
          "Champigny-sur-Marne est au cœur de notre zone d'intervention : nous rejoignons Le Perreux-sur-Marne, Joinville-le-Pont ou Bry-sur-Marne en quelques minutes, et l'ensemble du Val-de-Marne dans la foulée. Que vous soyez champenois ou dans une commune voisine, vous bénéficiez du même service : déplacement gratuit, devis gratuit et un contact direct.",
        ],
      },
    ],
    ctaTitle: "Votre couvreur à Champigny vous répond directement",
    photo: "/showroom.webp",
    photoAlt: "Showroom MSC Toitures — 34 boulevard de Polangis, Champigny-sur-Marne",
    linksBlock: {
      title: "Autour de Champigny-sur-Marne",
      links: [
        { to: "/couvreur-94", label: "Couvreur 94" },
        { to: "/couvreur-joinville-le-pont", label: "Couvreur Joinville-le-Pont" },
        { to: "/couvreur-le-perreux-sur-marne", label: "Couvreur Le Perreux-sur-Marne" },
        { to: "/couvreur-bry-sur-marne", label: "Couvreur Bry-sur-Marne" },
        { to: "/couvreur-chennevieres-sur-marne", label: "Couvreur Chennevières-sur-Marne" },
        { to: "/couvreur-saint-maur-des-fosses", label: "Couvreur Saint-Maur-des-Fossés" },
      ],
    },
  },
  {
    slug: "reparation-toiture-94",
    footerLabel: "Réparation toiture 94",
    metaTitle: "Réparation toiture 94 — MSC Toitures | Dépannage couvreur Val-de-Marne",
    metaDescription:
      "Réparation de toiture dans le Val-de-Marne (94) : tuiles cassées, faitage, ardoises, dépannage toiture. MSC Toitures intervient dans tout le 94. Déplacement et devis gratuits.",
    overline: "Dépannage & réparation — Val-de-Marne",
    h1: "Réparation de toiture dans le 94 : redonner à votre toit son étanchéité",
    intro: [
      "Une toiture n'a pas besoin d'être vieille pour avoir besoin de réparations. Une tempête, une branche, une tuile mal reposée après le passage d'un antenniste : il suffit parfois d'un défaut minime pour que l'eau trouve son chemin. MSC Toitures intervient dans tout le Val-de-Marne pour réparer votre toiture avant que le problème ne s'aggrave.",
      "Notre règle : réparer ce qui doit l'être, et seulement cela. Lors du diagnostic — gratuit — nous distinguons ce qui relève d'une simple réparation de ce qui demanderait une rénovation plus large, et nous vous le disons franchement.",
    ],
    blocks: [
      {
        h2: "Les réparations de toiture les plus fréquentes dans le 94",
        paragraphs: [
          "Après des années d'interventions dans le Val-de-Marne, certains sinistres reviennent régulièrement. Les identifier tôt permet souvent d'éviter des dégâts bien plus coûteux sur la charpente, l'isolation et les plafonds.",
        ],
        list: [
          "Tuiles cassées, fendues, déplacées ou envolées par le vent",
          "Faitage et arêtiers descellés",
          "Rive de toiture et cache-moineaux dégradés",
          "Abergement de cheminée ou de velux fissuré",
          "Noue ou chéneau percé ou obstrué",
          "Sous-toiture ou écran de sous-toiture déchiré",
        ],
      },
      {
        h2: "Une tuile cassée, vraiment grave ?",
        paragraphs: [
          "Une seule tuile cassée ne fait pas toujours couler un plafond — la sous-toiture tient parfois temporairement le rôle de barrière. Mais c'est un faux réconfort : l'eau qui s'infiltre s'écoule sous les tuiles voisines, humidifie les liteaux et finit par tacher loin du point d'entrée réel. C'est ce qui rend les fuites si difficiles à localiser sans monter sur le toit.",
          "Réparer une tuile coûte peu. Réparer une charpente humide et un plafond dégradé coûte beaucoup plus. C'est toute la logique du dépannage toiture : intervenir tôt, réparer juste.",
        ],
      },
      {
        h2: "Comment nous réparons votre toiture",
        paragraphs: [
          "Nous commençons par monter voir la toiture — pas par deviner depuis le trottoir. Le diagnostic gratuit nous permet d'identifier chaque point défaillant : couverture, zinguerie, points singuliers. Nous vous montrons ce que nous avons constaté et vous recevez un devis gratuit, détaillé poste par poste.",
          "Les réparations sont ensuite réalisées avec des matériaux adaptés à votre couverture existante — tuiles à l'identique quand c'est possible — pour un résultat étanche et discret visuellement.",
        ],
      },
    ],
    ctaTitle: "Une réparation de toiture dans le 94 ? Parlons-en",
    photo: "/photos/reparation-toiture-94.webp",
    photoAlt: "Réparation de toiture en zinc avec souche de cheminée par MSC Toitures dans le Val-de-Marne",
  },
  {
    slug: "fuite-toiture-94",
    footerLabel: "Fuite toiture 94",
    metaTitle: "Fuite toiture 94 — MSC Toitures | Recherche de fuite & réparation Val-de-Marne",
    metaDescription:
      "Fuite de toiture dans le Val-de-Marne (94) ? MSC Toitures recherche l'origine des infiltrations et répare durablement. Intervention dans tout le 94. Déplacement et devis gratuits.",
    overline: "Recherche de fuite — Intervention dans le 94",
    h1: "Fuite de toiture dans le 94 : trouver la vraie origine de l'infiltration",
    intro: [
      "Une tache au plafond, une trace d'humidité qui descend le long d'un mur, un goutte-à-goutte dans les combles les jours de pluie : une fuite de toiture est toujours un signal à prendre au sérieux. MSC Toitures intervient dans tout le Val-de-Marne pour rechercher l'origine des infiltrations et effectuer les réparations nécessaires.",
      "La règle d'or de la recherche de fuite : le point où l'eau apparaît n'est presque jamais le point où elle entre. L'eau chemine sous la couverture, le long des liteaux et des chevrons, parfois sur plusieurs mètres. C'est pourquoi une réparation « à l'aveugle » au niveau de la tache échoue si souvent.",
    ],
    blocks: [
      {
        h2: "D'où viennent les infiltrations d'eau ?",
        paragraphs: [
          "Sur les toitures du Val-de-Marne, les causes de fuite que nous rencontrons le plus souvent tiennent en quelques familles de problèmes. Toutes ont un point commun : elles empirent avec le temps, la pluie et le gel.",
        ],
        list: [
          "Tuiles ou ardoises cassées, déplacées ou poreuses avec l'âge",
          "Zinguerie défaillante : noue, chéneau, abergement de cheminée fissuré",
          "Gouttières bouchées qui refoulent l'eau sous la couverture",
          "Raccords d'étanchéité vieillissants autour des velux et sorties de toit",
          "Mousse accumulée retenant l'humidité et soulevant les tuiles",
          "Toit-terrasse ou acrotère dont l'étanchéité est fatiguée",
        ],
      },
      {
        h2: "Pourquoi ne pas attendre",
        paragraphs: [
          "L'eau est patiente et discrète. Une infiltration même légère humidifie d'abord l'isolant — qui perd son efficacité — puis les bois de charpente, qui peuvent se dégrader durablement si l'humidité s'installe. Les taches sur les plafonds et les peintures qui cloquent n'arrivent qu'ensuite, quand le mal est déjà fait.",
          "Faire rechercher la fuite dès les premiers signes, c'est presque toujours transformer un gros chantier en une réparation simple. Le déplacement pour le diagnostic est gratuit : autant ne pas attendre la prochaine grosse pluie.",
        ],
      },
      {
        h2: "Notre méthode de recherche de fuite",
        paragraphs: [
          "Nous commençons par vous écouter : quand la fuite apparaît-elle, par quel vent, quelle pluie, depuis quand ? Ces détails orientent souvent le diagnostic. Nous inspectons ensuite les combles et la couverture elle-même, en remontant le chemin de l'eau depuis les traces visibles jusqu'au point d'entrée réel.",
          "Une fois l'origine identifiée, nous vous expliquons la réparation nécessaire — remplacement d'éléments, reprise de zinguerie, traitement d'étanchéité — dans un devis gratuit et détaillé. L'objectif n'est pas de masquer la trace, mais de stopper l'infiltration à sa source.",
        ],
      },
    ],
    ctaTitle: "Fuite de toiture ? Appelez MSC Toitures",
    photo: "/photos/refection.webp",
    photoAlt: "Intervention MSC Toitures sur une maison du Val-de-Marne",
  },
  {
    slug: "renovation-toiture-94",
    footerLabel: "Rénovation toiture 94",
    metaTitle: "Rénovation toiture 94 — MSC Toitures | Rénover sa toiture dans le Val-de-Marne",
    metaDescription:
      "Rénovation de toiture dans le Val-de-Marne (94) : toiture vieillissante, remplacement de couverture, zinguerie et étanchéité. MSC Toitures — déplacement et devis gratuits.",
    overline: "Rénovation de couverture — Val-de-Marne",
    h1: "Rénovation de toiture dans le 94 : offrir une seconde vie à votre toit",
    intro: [
      "Une toiture ne dure pas éternellement. Après plusieurs décennies, les tuiles deviennent poreuses, la zinguerie fatigue, l'étanchéité n'est plus ce qu'elle était. Quand les réparations ponctuelles ne suffisent plus, la rénovation de toiture devient le choix raisonnable. MSC Toitures accompagne les propriétaires du Val-de-Marne dans ce projet, du premier diagnostic à la dernière finition.",
      "Rénover, ce n'est pas forcément tout refaire : selon l'état réel de votre couverture, la rénovation peut être partielle — un versant, la zinguerie, l'étanchéité — ou complète. C'est précisément le rôle du diagnostic gratuit de le déterminer.",
    ],
    blocks: [
      {
        h2: "Comment savoir si votre toiture est à rénover ?",
        paragraphs: [
          "Certains signes ne trompent pas. Si vous en cumulez plusieurs, il est temps de faire examiner votre couverture par un couvreur.",
        ],
        list: [
          "Tuiles qui s'effritent, noircissent ou deviennent poreuses",
          "Fuites à répétition malgré les réparations",
          "Mousse et lichen incrustés qui reviennent chaque année",
          "Zinguerie corrodée : gouttières, noues et chéneaux fatigués",
          "Toiture de plusieurs décennies jamais rénovée",
          "Factures de chauffage en hausse et combles mal isolés",
        ],
      },
      {
        h2: "Rénovation partielle ou complète : laquelle choisir ?",
        paragraphs: [
          "La rénovation partielle convient lorsque la structure est saine et que seules certaines zones sont usées : un versant exposé au nord, la zinguerie, le faitage. Elle permet de prolonger la vie de la toiture à moindre coût.",
          "La rénovation complète s'impose quand la couverture a globalement atteint la fin de sa vie. C'est l'occasion de repartir sur des bases saines : vérification de la charpente, écran de sous-toiture, nouvelle couverture, zinguerie neuve — et de profiter du chantier pour améliorer l'isolation des combles si nécessaire.",
        ],
      },
      {
        h2: "Un projet de rénovation, étape par étape",
        paragraphs: [
          "Tout commence par un rendez-vous à votre domicile — déplacement gratuit dans tout le 94. Nous montons sur le toit, examinons la couverture, la charpente visible, la zinguerie et l'étanchéité, puis nous vous expliquons ce que nous voyons, photos à l'appui.",
          "Vous recevez ensuite un devis gratuit et détaillé : nature des travaux, matériaux, organisation du chantier. Pendant les travaux, la maison reste protégée et le chantier est tenu propre. À la fin, vous réceptionnez une toiture à nouveau étanche, saine et durable.",
        ],
      },
    ],
    ctaTitle: "Votre toiture vieillit ? Parlons rénovation",
    photo: "/photos/refection-pendant.webp",
    photoAlt: "Rénovation de toiture en cours : liteaux et écran de sous-toiture posés par MSC Toitures",
  },
  {
    slug: "zinguerie-94",
    footerLabel: "Zinguerie 94",
    metaTitle: "Zinguerie 94 — MSC Toitures | Gouttières, chéneaux & abergements Val-de-Marne",
    metaDescription:
      "Travaux de zinguerie dans le Val-de-Marne (94) : réparation de gouttières, chéneaux, noues, abergements de cheminée. MSC Toitures — déplacement et devis gratuits dans tout le 94.",
    overline: "Zinguerie & évacuation des eaux — Val-de-Marne",
    h1: "Zinguerie dans le 94 : le détail qui protège toute votre toiture",
    intro: [
      "On pense d'abord aux tuiles quand on parle de toiture, mais la zinguerie est tout aussi décisive : gouttières, chéneaux, noues, abergements de cheminée, solins… Ce sont ces pièces de zinc qui guident l'eau de pluie hors de votre maison. Quand elles faiblissent, les infiltrations ne tardent pas.",
      "MSC Toitures réalise tous les travaux de zinguerie dans le Val-de-Marne : réparation de gouttières, remplacement de chéneaux, refaçonnage d'abergements, soudures et étanchéité des raccords. Déplacement et devis gratuits dans tout le 94.",
    ],
    blocks: [
      {
        h2: "À quoi sert exactement la zinguerie ?",
        paragraphs: [
          "Chaque élément de zinguerie a un rôle précis dans l'évacuation des eaux pluviales. Comprendre ces rôles aide à repérer les signes d'usure avant qu'ils ne deviennent des fuites.",
        ],
        list: [
          "Gouttières : collectent l'eau en bas de pente et la dirigent vers les descentes",
          "Chéneaux : canalisent l'eau entre deux pans de toiture ou le long d'un mur",
          "Noues : assurent la jonction étanche de deux versants qui se rencontrent",
          "Abergements : scellent le contour des cheminées, velux et sorties de toit",
          "Solins et faitières ventilées : protègent les raccords avec la maçonnerie",
        ],
      },
      {
        h2: "Gouttière abîmée : les signes qui doivent alerter",
        paragraphs: [
          "Une gouttière qui déborde en cas de pluie modérée, qui s'affaisse entre deux crochets, qui fuit aux joints ou dont la descente laisse couler l'eau le long de la façade : autant de signes d'une zinguerie en souffrance. À terme, l'eau mal évacuée tache les murs, fragilise les fondations et s'infiltre sous la couverture.",
          "La réparation de gouttière est l'un des travaux de toiture les plus rentables qui soient : un joint refait, une pente corrigée, un tronçon remplacé suffisent souvent à protéger toute une façade. Encore faut-il le faire avant que l'eau n'ait travaillé.",
        ],
      },
      {
        h2: "Des travaux de zinguerie sur mesure",
        paragraphs: [
          "La zinguerie est un métier de précision : chaque maison a ses angles, ses longueurs, ses raccords particuliers. Nous façonnons et adaptons les éléments aux dimensions réelles de votre toiture, avec des finitions propres — soudures soignées, pentes correctes, fixations solides.",
          "Comme pour tous nos travaux, tout commence par un déplacement gratuit pour constater l'état de votre zinguerie, suivi d'un devis gratuit et détaillé. Vous savez ce qui sera fait, et pourquoi, avant le premier coup d'outil.",
        ],
      },
    ],
    ctaTitle: "Gouttières, noues, abergements : confiez-les à un pro",
    photo: "/photos/zinguerie-apres.webp",
    photoAlt: "Toiture en zinc après travaux de zinguerie par MSC Toitures dans le Val-de-Marne",
  },
];

export const seoPages = [...corePages, ...servicesPages];
